<template>
  <v-card>
    <v-data-iterator class="mt-5" :items="records" :page="current_page" :items-per-page="50">
      <template v-slot:header>
        <v-toolbar flat color="white" density="compact">
          <v-text-field
              density="compact"
              class="reg-normal text-primary ml-5"
              base-color="border-tertiary"
              bg-color="secondary"
              color="primary"
              v-model="advanced_search.text_search"
              v-debounce:800ms.lock="showRecords"
              @click:clear="clearSearch('text_search')"
              hide-details
              single-line
              flat
              clearable>
            <template #label>
              <span class="sm-normal text-subtle">{{ $store.getters.translate('search') }}</span>
            </template>
          </v-text-field>
          <v-autocomplete
              class="reg-normal text-primary ml-5"
              base-color="border-tertiary"
              bg-color="secondary"
              density="compact"
              v-model="advanced_search.root_asset_name"
              :items="advanced_search_models.root_asset_name"
              @update:model-value="showRecords"
              :return-object="false"
              hide-details
              single-line
              clearable>
            <template #label>
              <span class="sm-normal text-subtle">{{ $store.getters.translate('root_asset_name') }}</span>
            </template>
          </v-autocomplete>
          <v-autocomplete
              class="reg-normal text-primary ml-5"
              base-color="border-tertiary"
              bg-color="secondary"
              density="compact"
              v-model="advanced_search.cluster"
              :items="advanced_search_models.cluster"
              @update:model-value="showRecords"
              :return-object="false"
              hide-details
              single-line
              clearable>
            <template #label>
              <span class="sm-normal text-subtle">{{ $store.getters.translate('cluster') }}</span>
            </template>
          </v-autocomplete>
          <v-autocomplete
              class="reg-normal text-primary ml-5"
              base-color="border-tertiary"
              bg-color="secondary"
              color="primary"
              density="compact"
              v-model="order_by"
              :items="[{ value: 'id_asc', text: 'ID ascending'}, { value: 'id_desc', text: 'ID descending'}, { value: 'priority_asc', text: 'Priority ascending'}, { value: 'priority_desc', text: 'Priority descending'}]"
              @update:model-value="showRecords"
              :return-object="false"
              item-value="value"
              item-title="text"
              hide-details
              single-line>
            <template #label>
              <span class="sm-normal text-subtle">{{ $store.getters.translate('sort_order') }}</span>
            </template>
          </v-autocomplete>
          <v-spacer/>
          <v-menu>
            <template #activator="{ props }">
              <v-btn elevation="0" icon v-bind="props">
                <PhDotsThreeVertical size="24" style="cursor: pointer;"/>
              </v-btn>
            </template>
            <v-list>
              <v-list-item v-if="hide_closed_defects" @click="setClosedState(false)">
                <template #prepend><PhEye size="24"/></template>
                <v-list-item-title class="sm-normal link ml-2">
                  <span>{{ $store.getters.translate('show_closed') }}</span>
                </v-list-item-title>
              </v-list-item>
              <v-list-item v-else @click="setClosedState(true)">
                <template #prepend><PhEyeSlash size="24"/></template>
                <v-list-item-title class="sm-normal link ml-2">
                  <span>{{ $store.getters.translate('hide_closed') }}</span>
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </v-toolbar>
      </template>
      <template v-slot:default="{ items, isExpanded, toggleExpand }">
        <template v-for="(item, index) in items" :key="index">
          <v-card class="ma-5 pa-5" rounded="xl" border="sm" variant="outlined">
            <v-row>
              <v-col cols="11">
                <v-row class="rounded-xl" style="background-color: #faebec; align-items: center; cursor: pointer;" @click.stop="$emit('edit', item.raw)">
                  <v-col class="ml-3">
                    <span class="sm-bold">{{ $store.getters.translate('id') + ': ' }}</span>
                    <span class="sm-normal">{{ item.raw.id }}</span>
                  </v-col>
                  <v-col>
                    <span class="sm-bold">{{ $store.getters.translate('defect_status') + ':' }}</span>
                    <template v-if="item.raw.opened">
                      <v-icon color="red" size="8" class="ml-2 mr-2">mdi-circle</v-icon>
                      <span class="sm-normal">Not Ready</span>
                    </template>
                    <template v-else>
                      <v-icon color="green" size="8" class="ml-2 mr-2">mdi-circle</v-icon>
                      <span class="sm-normal">Ready</span>
                    </template>
                  </v-col>
                  <v-col class="pa-0">
                    <span class="sm-bold" style="float: left; display: block; height: 36px; align-content: center;">{{ $store.getters.translate('priority') + ':' }}</span>
                    <PhNumberCircleZero v-if="item.raw.priority === 0" color="red" size="36" class="ml-2"/>
                    <PhNumberCircleOne v-else-if="item.raw.priority === 1" color="red" size="36" class="ml-2"/>
                    <PhNumberCircleTwo v-else-if="item.raw.priority === 2" color="orange" size="36" class="ml-2"/>
                    <PhNumberCircleThree v-else-if="item.raw.priority === 3" color="orange" size="36" class="ml-2"/>
                    <span v-else class="sm-normal pl-1" style="display: block; height: 36px; align-content: center;">Not set</span>
                  </v-col>
                  <v-col>
                    <span class="sm-bold">{{ $store.getters.translate('cluster') + ': ' }}</span>
                    <span class="sm-normal">{{ item.raw.cluster }}</span>
                  </v-col>
                  <v-col>
                    <span class="sm-bold">{{ $store.getters.translate('inspection') + ': ' }}</span>
                    <span class="sm-normal">{{ item.raw.inspection_name }}</span>
                  </v-col>
                </v-row>
                <v-row class="mb-0">
                  <v-col>
                    <div class="sm-bold">{{ $store.getters.translate('section') }}</div>
                    <div class="sm-normal">{{ $store.getters.translate(item.raw.distribution_device_function_name) }}</div>
                  </v-col>
                  <v-col>
                    <div class="sm-bold">{{ $store.getters.translate('category') }}</div>
                    <div class="sm-normal">{{ $store.getters.translate(item.raw.deficiency_group) }}</div>
                  </v-col>
                  <v-col>
                    <div class="sm-bold">{{ $store.getters.translate('distribution_panel_name') }}</div>
                    <div class="sm-normal">{{ item.raw.distribution_panel_name }}</div>
                  </v-col>
                  <v-col>
                    <div class="sm-bold">{{ $store.getters.translate('circuit_number') }}</div>
                    <div class="sm-normal">{{ item.raw.circuit_number }}</div>
                  </v-col>
                  <v-col>
                    <div class="sm-bold">{{ $store.getters.translate('tag_number_name') }}</div>
                    <div class="sm-normal">{{ item.raw.tag_number_name }}</div>
                  </v-col>
                  <v-col>
                    <div class="sm-bold">{{ $store.getters.translate('description') }}</div>
                    <div class="sm-normal">{{ item.raw.description }}</div>
                  </v-col>
                  <v-col>
                    <div class="sm-bold">{{ $store.getters.translate('location_name') }}</div>
                    <div class="sm-normal">{{ item.raw.location_name }}</div>
                  </v-col>
                  <v-col>
                    <div class="sm-bold">{{ $store.getters.translate('root_asset_name') }}</div>
                    <div class="sm-normal">{{ item.raw.root_asset_name }}</div>
                  </v-col>
                </v-row>
                <v-row class="mb-0">
                  <v-col class="pa-0" style="background-color: #F6F6F6; min-height: 100px;">
                    <v-sheet color="red-darken-1" min-height="100px" width="3" class="position-absolute"/>
                    <div class="text-red-darken-1 sm-bold ml-5 mt-2">
                      {{ $store.getters.translate("defect_description") }}
                    </div>
                    <div class="sm-normal text-primary ml-5 mt-2 mb-2">
                      {{ item.raw.defect_description }}
                    </div>
                  </v-col>
                  <v-col class="pa-0 ml-5" style="background-color: #F6F6F6; min-height: 100px;">
                    <v-sheet color="orange-darken-1" min-height="100px" width="3" class="position-absolute"/>
                    <div class="text-orange-darken-1 sm-bold ml-5 mt-2">
                      {{ $store.getters.translate("remarks") }}
                    </div>
                    <div class="sm-normal text-primary ml-5 mt-2 mb-2">
                      {{ item.raw.remarks }}
                    </div>
                  </v-col>
                </v-row>
                <v-expand-transition>
                  <v-row v-if="isExpanded(item)">
                    <v-col>
                      <v-row>
                        <v-col>
                          <v-btn-toggle v-model="item.raw.defect_status" density="compact" base-color="white" color="primary" rounded="xl" border>
                            <v-btn value="repaired" color="green" @click="updateDefectStatus(item)">
                              <v-icon icon="mdi-check" start/>
                              {{ $store.getters.translate('repaired') }}
                            </v-btn>
                            <v-btn value="waiting_on_material" color="orange" @click="updateDefectStatus(item)">
                              <v-icon icon="mdi-clock-outline" start/>
                              {{ $store.getters.translate('waiting_on_material') }}
                            </v-btn>
                            <v-btn value="waiting_technical_authority" color="orange" @click="updateDefectStatus(item)">
                              <v-icon icon="mdi-clock-outline" start/>
                              {{ $store.getters.translate('waiting_technical_authority') }}
                            </v-btn>
                            <v-btn value="could_not_repair" color="red" @click="updateDefectStatus(item)">
                              <v-icon icon="mdi-close" start/>
                              {{ $store.getters.translate('could_not_repair') }}
                            </v-btn>
                          </v-btn-toggle>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <span class="sm-bold">{{ $store.getters.translate('technical_drawing') + ': ' }}</span>
                          <span class="sm-normal">{{ item.raw.drawing_number }}</span>
                          <span class="sm-normal" v-if="item.raw.page">{{ ', ' + $store.getters.translate('page') + ': ' + item.raw.page }}</span>
                        </v-col>
                        <v-col>
                          <span class="sm-bold">{{ $store.getters.translate('revision') + ': ' }}</span>
                          <span class="sm-normal">{{ item.raw.revision }}</span>
                        </v-col>
                        <v-col class="pa-0">
                          <base-link-button v-if="item.raw.article_id" @action="$router.push('/articles/' + item.raw.article_id)">
                            <template #prepend><PhArrowSquareOut style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
                            {{ $store.getters.translate("view") + ' ' + $store.getters.translate("article") }}
                          </base-link-button>
                        </v-col>
                        <v-col class="pa-0">
                          <base-link-button v-if="item.raw.inspection_id" @action="$router.push('/inspections/' + item.raw.inspection_id)">
                            <template #prepend><PhArrowSquareOut style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
                            {{ $store.getters.translate("view") + ' ' + $store.getters.translate("inspection") }}
                          </base-link-button>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-expand-transition>
              </v-col>
              <v-col class="pa-0 ml-3">
                <v-layout v-if="item.raw.image" align-center justify-center column fill-height>
                  <v-img :src="item.raw.image" class="ma-auto"/>
                </v-layout>
                <base-link-button class="mt-3 pa-2" v-if="isExpanded(item)" @action="toggleExpand(item)">
                  <template #prepend><PhCaretUp style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
                  {{ $store.getters.translate('view_less') }}
                </base-link-button>
                <base-link-button class="mt-3 pa-2" v-else @action="toggleExpand(item)">
                  <template #prepend><PhCaretDown style="vertical-align: middle; margin-right: 5px;" size="20"/></template>
                  {{ $store.getters.translate('view_more') }}
                </base-link-button>
              </v-col>
            </v-row>
          </v-card>
        </template>
      </template>
      <template v-slot:footer="{ pageCount }">
        <v-pagination v-model="current_page" :length="pageCount" rounded="circle"/>
      </template>
    </v-data-iterator>
  </v-card>
</template>

<script>
import helpFunctions from "../../plugins/helpFunctions";
import BaseLinkButton from "../../components/commonComponents/BaseLinkButton";
import { PhArrowSquareOut, PhCaretDown, PhCaretUp, PhDotsThreeVertical, PhEye, PhEyeSlash, PhNumberCircleOne, PhNumberCircleThree, PhNumberCircleTwo, PhNumberCircleZero } from "@phosphor-icons/vue";

export default {
  components: {
    BaseLinkButton,
    PhCaretUp, PhCaretDown, PhArrowSquareOut, PhNumberCircleZero, PhEyeSlash, PhEye, PhDotsThreeVertical, PhNumberCircleThree, PhNumberCircleTwo, PhNumberCircleOne,
  },
  data() {
    return {
      page: helpFunctions.pages.defects,
      all_records: [],
      records: [],
      hide_closed_defects: true,
      advanced_search: {
        text_search: null,
        root_asset_name: null,
        cluster: null,
      },
      advanced_search_models: {
        root_asset_name: [],
        cluster: [],
      },
      current_page: 1,
      order_by: 'priority_asc'
    };
  },
  methods: {
    fillAdvancedSearchArrays() {
      this.all_records.forEach(record => {
        if(record.root_asset_name && !this.advanced_search_models.root_asset_name.includes(record.root_asset_name)) {
          this.advanced_search_models.root_asset_name.push(record.root_asset_name);
        }
        if(record.cluster && !this.advanced_search_models.cluster.includes(record.cluster)) {
          this.advanced_search_models.cluster.push(record.cluster);
        }
      });
      this.showRecords();
    },
    showRecords() {
      let sorted_array = this.all_records;
      if(this.hide_closed_defects) {
        sorted_array = sorted_array.filter((item) => item.opened);
      }
      if(this.advanced_search.root_asset_name) {
        sorted_array = sorted_array.filter(item => item.root_asset_name === this.advanced_search.root_asset_name);
      }
      if(this.advanced_search.cluster) {
        sorted_array = sorted_array.filter(item => item.cluster === this.advanced_search.cluster);
      }
      if(this.advanced_search.text_search) {
        sorted_array = sorted_array.filter(item => (item.distribution_device_function_name && this.$store.getters.translate(item.distribution_device_function_name).toLowerCase().includes(this.advanced_search.text_search.toLowerCase())) ||
            (item.deficiency_group && this.$store.getters.translate(item.deficiency_group).toLowerCase().includes(this.advanced_search.text_search.toLowerCase())) ||
            (item.distribution_panel_name && item.distribution_panel_name.toLowerCase().includes(this.advanced_search.text_search.toLowerCase())) ||
            (item.tag_number_name && item.tag_number_name.toLowerCase().includes(this.advanced_search.text_search.toLowerCase())) ||
            (item.description && item.description.toLowerCase().includes(this.advanced_search.text_search.toLowerCase())) ||
            (item.location_name && item.location_name.toLowerCase().includes(this.advanced_search.text_search.toLowerCase())) ||
            (item.defect_description && item.defect_description.toLowerCase().includes(this.advanced_search.text_search.toLowerCase())) ||
            (item.remarks && item.remarks.toLowerCase().includes(this.advanced_search.text_search.toLowerCase())));
      }
      if(this.order_by === 'id_asc') {
        this.records = this.$lodash.orderBy(sorted_array, 'id', 'asc');
      }
      else if(this.order_by === 'id_desc') {
        this.records = this.$lodash.orderBy(sorted_array, 'id', 'desc');
      }
      else if(this.order_by === 'priority_asc') {
        this.records = this.$lodash.orderBy(sorted_array, 'priority', 'asc');
      }
      else if(this.order_by === 'priority_desc') {
        this.records = this.$lodash.orderBy(sorted_array, 'priority', 'desc');
      }
      this.current_page = 1;
    },
    clearSearch(key) {
      this.advanced_search[key] = null;
      this.showRecords();
    },
    setClosedState(new_state) {
      this.hide_closed_defects = new_state;
      this.showRecords();
    },
    async updateDefectStatus(item) {
      await helpFunctions.postCustomRoute(this.$toast, "change-defect-status", { id: item.raw.id, defect_status: item.raw.defect_status }, true, true);
    },
  },
};
</script>